<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  [style]="{ width: '400px' }"
  styleClass="confirmation-dialog rounded-lg shadow-lg"
>
  <div class="flex flex-col items-center justify-center p-6 text-center">
    <!-- Ícono -->
    <i
      class="pi mb-4"
      [ngClass]="icon"
      [ngStyle]="isTailwindColor(iconColor) ? { 'font-size': iconSize } : { 'font-size': iconSize, 'color': iconColor }"
      [class]="isTailwindColor(iconColor) ? iconColor : ''"
    ></i>

    <!-- Mensaje -->
    <div class="mb-6">
      <p class="text-gray-900 text-xxl leading-6 whitespace-pre-line">{{ message }}</p>
    </div>

    <!-- Botones -->
    <div class="flex gap-3 w-full">
      <button
        pButton
        type="button"
        [label]="cancelLabel"
        (click)="onCancelAction()"
        [class]="'p-button ' + cancelButtonClass"
        class="flex-1"
      ></button>
      <button
        pButton
        type="button"
        [label]="confirmLabel"
        (click)="onConfirmAction()"
        [class]="'p-button ' + confirmButtonClass"
        class="flex-1"
      ></button>
    </div>
  </div>
</p-dialog>
